/**
 * Convert legacy FAQ HTML to inert text before React renders it.
 *
 * This deliberately does not return HTML. React escapes the result, so even
 * malformed markup, event handlers, SVG and javascript: URLs remain text.
 * Portable Text is the supported format for FAQ links and rich formatting.
 */
export function htmlToPlainText(html) {
    if (!html) return '';

    return String(html)
        .replace(/<br\s*\/?\s*>/gi, '\n')
        .replace(/<\/(?:p|div|li|button|a)>/gi, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#(?:39|x27);/gi, "'")
        .replace(/\n{3,}/g, '\n\n')
        .trim();
}

